module.exports = __webpack_public_path__ + "static/sticky-add-to-cart-a73e7e9b377bc98349baaa759453ea38.jpg";